// 清单检查接口管理
import request from '../request.js'

// 获取编码分类码表 --- 郑志会
const getCodeList = function (data) {
    return request({
        url: 'sysDict/selectSysDeic',
        method: 'post',
        data
    })
}

// 获取清单数据 --- 郑志会
const getListInfo = function (data) {
    return request({
        url: 'busDetailedAnalysisApproval/selectDetailedAnalysis',
        method: 'post',
        data
    })
}


// 清单检查--获取清单编码、清单名称 --- 叶凡
const getCodesAndNames = function (data) {
    return request({
        url: 'busDetailedAnalysisApproval/getCodesAndNames',
        method: 'post',
        data
    })
}

// 材价检查 --- 获取 材价检查数据 --- 郑志会
const getMaterialInfo = function (data) {
    return request({
        url: 'fileResource/selectAllFileResource',
        method: 'post',
        data
    })
}


// 材价检查 --- 获取计量单位、材价名称 --- 郑志会
const getMaterialNames = function (data) {
    return request({
        url: 'fileResource/getUnitsAndNames',
        method: 'post',
        data
    })
}

// 清单检查 --- 获取定额 --- 李开明
const getQuotaList = function (data) {
    return request({
        url: 'bus/busdetailedquota/selectQuotasByBillId',
        method: 'post',
        data
    })
}

// 清单检查 --- 获取定额下面的资源 --- 李开明
const getQuotaChild = function (data) {
    return request({
        url: 'bus/busdetailedquotaresource/selectQuotasResourceByQuotaId',
        method: 'post',
        data
    })
}

// 清标--获取清单单位、清单名称
const getClearNameUnits = function (data) {
    return request({
        url: 'busDetailedAnalysisApproval/getClearNameUnits',
        method: 'post',
        data
    })
}

export {
    getCodeList,
    getListInfo,
    getQuotaList,
    getQuotaChild,
    getMaterialInfo,
    getMaterialNames,
    getCodesAndNames,
    getClearNameUnits
}